export default "__VITE_ASSET__fcf75d19__"